import type { SVGProps } from "react";
const SvgAliorBankLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-0.03 -0.03 85.04 85.04"
    {...props}
  >
    <linearGradient
      id="AliorBankLogo_min_svg__a"
      x1={-101.92}
      x2={-186.96}
      y1={-229.48}
      y2={-229.48}
      gradientTransform="translate(186.93 271.97)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0.5} stopColor="#6b113d" />
      <stop offset={1} stopColor="#490724" />
    </linearGradient>
    <path
      fill="url(#AliorBankLogo_min_svg__a)"
      d="M-.03-.03h85.04v85.04H-.03Z"
      style={{
        fill: "url(#AliorBankLogo_min_svg__a)",
      }}
    />
    <path
      fill="#fff"
      d="M28.56 42.5v12.33h6.6v1.88h-9.71V42.49zm12.1 0v14.2h-3.1V42.5zm19.81 7.01c0 4.47-3.43 7.5-8.5 7.5-2.22 0-4.1-.63-5.47-1.8a7.2 7.2 0 0 1-2.42-5.5c0-2.3.94-4.23 2.74-5.6a9 9 0 0 1 5.78-1.89c4.73 0 7.87 2.92 7.87 7.3m-13.12-.09c0 3.37 2.18 5.81 5.14 5.81 1.08 0 2.13-.38 2.96-1.05q1.75-1.47 1.75-4.26c0-3.5-2.13-5.92-5.18-5.92-2.76 0-4.67 2.22-4.67 5.42m16.49-6.93 5.34-.1c2.35 0 3.4.17 4.34.76a3.5 3.5 0 0 1 1.77 3.18c0 1.86-1.4 3.29-3.6 3.93 1.97 4.09 3.6 5.4 5.38 5.27l.06.1-.23.9c-.06.3-.67.45-1.74.45-1.7 0-2.96-.7-4.13-2.3-.62-.89-1.2-1.95-2.2-3.98-.4.02-.69.05-1.14.05-.25 0-.43 0-.74-.03v6h-3.11zm3.12 6.62c1.18.04 1.45.04 1.63.04 2.36 0 3.43-.83 3.43-2.64q-.01-1.66-1.37-2.17a5 5 0 0 0-2.08-.25l-1.61.02z"
    />
    <path
      fill="#eebb31"
      d="m11.26 62.34 2.2-.04c.8-.03 1.45-.03 1.78-.03 2.04 0 3.02.22 3.8.9a3.2 3.2 0 0 1 1.06 2.39c0 1.48-.7 2.39-2.26 3 1.01.17 1.48.33 2 .69.93.63 1.49 1.75 1.49 2.95 0 1.6-.92 3.02-2.4 3.71-1.05.48-2.08.6-4.65.6h-3.02zm3.63 6.01c1.4 0 1.97-.13 2.5-.6q.8-.7.8-1.92 0-1.4-.96-2.04c-.46-.29-1.07-.43-2.14-.43-.6 0-.87 0-2.08.1v4.9zm.06 7.03c1.68 0 2.76-.27 3.48-.85.64-.54 1-1.3 1-2.15 0-1.12-.56-2.02-1.5-2.46a7.4 7.4 0 0 0-3.06-.45H13v5.89zM30.7 62.34l5.48 14.18h-1.91l-1.68-4.59h-6.17l-1.9 4.59h-1.8l6.59-14.18zm-1.02 1.84-2.79 6.66h5.28zm10.12-1.84 9.67 11.27-.32-11.28h1.57l-.02 14.12-.76.27L39.7 64.9l.33 11.6h-1.56V62.33zm17.45 0v14.18H55.5V62.34zm9.44 0-7.27 6.3 7.61 7.87h-2.46l-7.21-7.58 7.07-6.6z"
    />
    <path
      fill="#fff"
      d="M16.71 41.9h-4.8l-.16.14s-.37 1.2-.4 1.48c.05.58 2.75.05 2.75.05L7.86 56.71h2.73l1.44-3.5h6.07l1.27 3.5h3.43zm-4.03 9.7 2.48-6.18 2.28 6.18z"
    />
  </svg>
);
export default SvgAliorBankLogo;
